<div class="modal-header">
  <h4 class="modal-title" id="modal-share">Share Review to...</h4>
  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="(sharingError$ | async) != null">
    {{ sharingError$ | async }}
    <button type="button" (click)="dismissError()">
      Dismiss
    </button>
  </div>
  <div *ngIf="(sharingError$ | async) == null">
    <div *ngIf="!(shareReviewSuccess$ | async)">
      <div *ngIf="locationFacebookTokenPairs == null" class="page-list-loading">
          Loading...
      </div>
      <div *ngIf="locationFacebookTokenPairs?.length === 0" class="page-list-noresults">
          <p>Connect a social media account in order to enable sharing to your pages.</p>
          <button type="button" aria-label="Social Sharing Settings" (click)="gotoSharing()">
              Social Sharing Settings
          </button>
      </div>
      <div *ngIf="locationFacebookTokenPairs?.length > 0" class="page-list-results">
          <social-sharing-item
              *ngFor="let token of locationFacebookTokenPairs"
              [token]="token"
              [selectionMode]="true"
              (click)="shareReviewToPage(review, token)">
          </social-sharing-item>
      </div>
    </div>
    <div *ngIf="(shareReviewSuccess$ | async)">
      Review shared successfully.
    </div>
  </div>
</div>